var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 text-right pad-20t-h10-80b" },
    [
      _c(
        "q-fab",
        {
          staticClass: "fixed",
          staticStyle: { right: "10px", bottom: "10px" },
          attrs: {
            push: "",
            direction: "left",
            color: "info",
            icon: "fa fa-info"
          }
        },
        _vm._l(_vm.ajudas, function(ajuda) {
          return _vm.ajudas
            ? _c(
                "q-fab-action",
                {
                  key: ajuda.id,
                  attrs: { color: ajuda.cor, icon: ajuda.icone }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      staticClass: "gvn-tooltip ",
                      attrs: {
                        anchor: "bottom left",
                        self: "top left",
                        offset: [10, 5]
                      }
                    },
                    [
                      _c(
                        "h6",
                        { staticClass: "mrg-v-10", class: ajuda.tituloClasse },
                        [
                          _c("q-icon", {
                            class: _vm.montaClasseIcone(ajuda.icone)
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(ajuda.tituloTexto) +
                              "\n        "
                          )
                        ],
                        1
                      ),
                      !ajuda.info
                        ? _c("span", [_vm._v(_vm._s(ajuda.descricao))])
                        : _c("div", [
                            _c("p", [_vm._v(_vm._s(ajuda.descricao))]),
                            _c("strong", { staticClass: "gvn-obs" }, [
                              _vm._v(_vm._s(ajuda.info))
                            ])
                          ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }